import ABCyaPhaser from "@abcya/abcya_phaser";
import FontKeys from "../FontKeys";
import SoundAssetKeys from "../SoundAssetKeys";
import UIAssetKeys from "../UIAssetKeys";
import Emitter from "./Emitter";

export default class LetterBubble extends Phaser.GameObjects.Container {
    constructor(scene, number) {
        super(scene);

        this.enabled = true;
        this.letters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q",
            "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

        this.number = number;
        this.letter = this.letters[number];

        this.backgroundImage = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._bubble, this).setOrigin(0);

        this.textLabel1 = ABCyaPhaser.Text.addText(this.backgroundImage.width / 2, this.backgroundImage.height / 2, 42, 0xffffff, FontKeys._odin_roundedregular, this.letter, this).setOrigin(0.5);

        this.createBodyDef();

        this.start();

        ABCyaPhaser.Container.setContainerInteractive(this, false);
        this.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.doClick, this);
    }

    createBodyDef() {
        let fixture = new Box2D.Dynamics.b2FixtureDef;
        fixture.density = 1;
        fixture.restitution = 0.6;
        fixture.shape = new Box2D.Collision.Shapes.b2CircleShape(10 / SCALE);

        this.fixture = fixture;

        let bodyDef = new Box2D.Dynamics.b2BodyDef;
        bodyDef.type = Box2D.Dynamics.b2Body.b2_dynamicBody;


        let globalPt = ABCyaPhaser.GameObjects.getScreenPosition(this);
        bodyDef.position.x = globalPt.x / SCALE;
        bodyDef.position.y = globalPt.y / SCALE;

        this.bodyDef = bodyDef;
    }

    start() {
        this.tickerEnabled = true;

        this.startTime = this.scene.time.now;
        this.scene.events.on(Phaser.Scenes.Events.PRE_UPDATE, this.handleTick, this);
        this.once(Phaser.GameObjects.Events.DESTROY, () => this.scene.events.off(Phaser.Scenes.Events.PRE_UPDATE, this.handleTick, this));

        let origY = 150;
        this.y = origY;

        // up and down motion
        this.scene.tweens.timeline({
            tweens:
                [
                    ABCyaPhaser.Tweens.createTween(this, 1500, { y: origY - 10, yoyo: true }, Phaser.Math.Easing.Linear),
                    ABCyaPhaser.Tweens.createTween(this, 1500, { y: origY + 10, yoyo: true }, Phaser.Math.Easing.Linear),
                ],
            loop: -1
        });
    }

    doClick() {
        if (!this.enabled) { return; }
        //explode and drop only once!
        this.enabled = false;
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pop, this.scene);

        this.backgroundImage.alpha = 0;

        this.stop();

        this.scene.tweens.killTweensOf(this);

        let emitter = new Emitter(this.scene, 5);
        emitter.x = -20;
        emitter.y = 20;

        this.add(emitter);
        emitter.emitParticles("bubble", 10);

        //drop number
        //we'll generate our body from the caller (GameScreen)
        //if its over the incorrect letter box that is full we initiate physics
        // else we animate a drop to the empty letter box
        this.clickAction(this);
    }

    stop() {
        this.scene.events.off(Phaser.Scenes.Events.PRE_UPDATE, this.handleTick, this);
        this.tickerEnabled = false;
    }

    handleTick(time, delta) {
        if (!this.tickerEnabled) {
            return;
        }

        this.x -= 60 * (delta/1000);

        if (this.x < -150 && this.scene != null) {
            this.stop();
            this.scene.tweens.killTweensOf(this);
            if (this.scene) {
                this.destroy();
            }
        }
    }

    cleanUp() {

        this.stop();
        this.scene.tweens.killTweensOf(this);
        this.destroy();
    }
}

const SCALE = 30;
const STEP = 20;
const TIMESTEP = 1 / STEP;